<script setup>
  import { ref } from 'vue';
//   import { ElCarousel,ElCarouselItem } from 'element-plus'
  const prevse  = ref('prevse')
  const activeIndex = ref(0)
  const userData = ref([
    {
        name:'睿渊',
        text:'vivo商店',
        mess:'坐地铁、乘公交都可以获得碳减排值，还能兑换数字人民币，低碳生活有我的一份助力！'
    },{
        name:'李帅兵',
        text:'应用宝',
        mess:'每天都会低碳出行积累碳减排量、参与日常任务得积分，感觉自己每一次的低碳行为都被量化、被激励，是一款会长期使用的APP。'
    },{
        name:'金金小李',
        text:'华为应用商店',
        mess:'在这里参与了很多低碳活动，通过地铁出行还能获得碳减排量并且抵扣乘车费，是我绿色出行的必备搭子！'
    },
  ])
  function prevsese(){
    prevse.value.prev()
    activeIndex.value--
  }
  function nextese(){
    prevse.value.next()
    activeIndex.value++
  }
</script>

<template>
    <div class="contactThomse">
        <img class="contactBg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/contactBg.png" alt="">
        <!-- 用户都在说 -->
        <div class="userCenter">
            <p class="userTxt">用户都在说</p>
            <p class="userTit">我们很开心分享我们的用户评论</p>
            <!-- <img class="contactaLeft1" @click="prevsese()" src="../assets/contactaLeft1.png" alt="">
            <img class="contactaLeft2" @click="nextese()" src="../assets/contactaLeft2.png" alt=""> -->
            <el-carousel initial-index="0" loop="false" :activeIndex="activeIndex" ref="prevse" :autoplay="false" arrow="never" indicator-position="none" :interval="5000">
                <el-carousel-item v-for="item in 1" :key="item">
                    <div class="userData">
                        <div v-for="(item,index) in userData" :key="item" class="userList">
                            <div class="userTop">
                                <!-- <img class="userAvatar" :src="require(`../assets/userAvatar${index+1}.png`)" alt=""> -->
                                <img class="userAvatar" :src="`https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/userAvatar${index+1}.png`" alt="">
                                <div class="userRight">
                                    <p class="userName">{{item.name}}</p>
                                    <p class="userText">{{item.text}}</p>
                                </div>
                            </div>
                            <div class="userMess">
                                {{item.mess}}
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>

        </div>
        <!-- 绿色出行 -->
         <div class="greenCenter">
            <img class="bg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/bg.png" alt="">
            <div class="greenCen">
                <div class="greenLeft">
                    <p class="greenTitle">绿色出行 健康中国</p>
                    <p class="greenText">联系我们</p>
                    <p class="greenText">官方客服电话：4006-520-628</p>
                    <p class="greenText">官方客服微信：lcago0628</p>
                </div>
                <img class="codeImg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/codeImg.png" alt="">
            </div>
         </div>
    </div>
</template>

<style lang="less" scoped>
p{
    margin: 0;
}
.contactThomse{
    width: 100%;
    position: relative;
    margin-top: 10%;
    .contactBg{
        width: 100%;
    }
    .greenCenter{
        width: 100%;
        margin-top: -20%;
        position: relative;
        .greenCen{
            width: 68%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            top: 0;
            transform: translateX(-50%);
            left: 50%;
            color: #fff;
            .greenLeft{
                text-align: left;
                .greenTitle{
                    font-size: 32px;
                    margin-bottom: 20px;
                    font-weight: 300;
                }
                .greenText{
                    font-size: 13px;
                    font-weight: 300;
                    line-height: 22px;
                }
            }
            .greenBg{
                width: 400px;
            }
            .codeImg{
                width: 150px;
            }
        }
        .bg{
            width: 80%;
        }
    }

    .userCenter{
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        .el-carousel__item{
            display: flex;
            justify-content: space-evenly;
            align-items: center;
        }
        .el-carousel__item h3 {
            // color: #475669;
            line-height: 300px;
            margin: 0;
            text-align: center;
        }

        .el-carousel__item:nth-child(2n) {
            // background-color: #99a9bf;
        }

        .el-carousel__item:nth-child(2n + 1) {
            // background-color: #d3dce6;
        }
        .userTxt{
            font-size: 16px;
            color: #00BB98;
            margin-top: 6%;
            margin-bottom: 20px;
            font-weight: 300;
        }
        .contactaLeft1{
            width: 35px;
            position: absolute;
            left: 8.5%;
            top: 62%;
            z-index: 10;
            cursor: pointer;
        }
        .contactaLeft2{
            width: 35px;
            position: absolute;
            right: 9%;
            top: 62%;
            z-index: 10;
            cursor: pointer;
        }
        .userTit{
            font-size: 32px;
            color: #000B33;
            font-weight: 300;
        }
        .userData{
            width: 80%;
            margin: 80px auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .userList{
                width: 32%;
                height: 270px;
                background: #fff;
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .userMess{
                    width: 77%;
                    text-align: left;
                }
                .userTop{
                    width: 77%;
                    display: flex;
                    align-items: center;
                    margin-bottom: 25px;
                    .userAvatar{
                        width: 60px;
                        border-radius: 30px;
                    }
                    .userRight{
                        margin-left: 20px;
                        .userName{
                            font-size: 17px;
                            color: #000B33;
                        }
                        .userText{
                            font-size: 13px;
                            color: rgba(#000B33,0.5);
                            text-align: left;
                            margin-top: 6px;
                        }
                    }

                }
            }
        }
    }
}
</style>